export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "eventProcessor.worker.a55d12a2a66a1f4d9729.worker.js");
}
